import React from 'react';
import { CrossSellRemoveLightBoxStore } from '../../_flux/stores/cross_sell_remove_light_box_store';
import { CrossSellRemoveLightBox } from '../../_flux/components/cross_sell_remove_light_box/cross_sell_remove_light_box';
import { expandAction, hideAction } from '../../_flux/actions/cross_sell_remove_light_box_actions';
import { clickOnLearnMore, clickOnOk, clickOnRemove, close } from '../../_modules/google_analytics/cross_sell_remove_light_box';
import { handleView } from '../handle_view';

const stores = {
    crossSellRemoveLightBox: CrossSellRemoveLightBoxStore,
};

function render(
    {
        crossSellRemoveLightBox,
    },
    options
) {
    const { visible, expanded } = crossSellRemoveLightBox;
    
    return (
        <CrossSellRemoveLightBox
            visible={visible}
            expanded={expanded}
            data={crossSellRemoveLightBox.obj}
            error={{ ...crossSellRemoveLightBox }}
            onExpand={onExpand}
            onAccept={onAccept}
            onClose={onClose}
            onRemove={options.onRemove}
        />
    );
}

const getOptions = options => ({
    ...options,
    onRemove: onRemoveFactory(options.onRemove),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onExpand = () => {
    expandAction();
    clickOnLearnMore();
};

const onAccept = () => {
    hideAction();
    clickOnOk();
};

export const onClose = () => {
    hideAction();
    close();
};

const onRemoveFactory = (onRemove) => (obj) => {
    onRemove(obj);
    clickOnRemove(obj);
};
